import React from 'react';
import { isEmpty } from 'ramda';
import { Panel, PageHeader } from 'react-bootstrap';

let features = __features__;//eslint-disable-line
if (process.env.NODE_ENV === 'test') {
  features = {
    requirementsAndExclusion: true
  }
}
const requirementsAndExclusions = features['requirementsAndExclusion'];//eslint-disable-line

export function TestResult({
  redirectUrl, 
  outcome, 
  loading,
  requirements,
  exclusions
}) {
  return (
    <div>
      <PageHeader>Questionnaire Completed</PageHeader>
      <Panel >
        <p>Here are the results of the questionnaire.</p>
        <p>
          <strong>Outcome: </strong> {outcome}
        </p>
        <p>
          <strong>Loading: </strong> {loading}
        </p>
        {requirementsAndExclusions &&
        <div>
          <p>
            <strong>Requirements: </strong>
            {isEmpty(requirements) && 'None'}
          </p>
          <ul>
            {requirements.map((requirement, index) => {
              return <li key={index}>{requirement.description}</li>
            })}
          </ul>
          <p>
            <strong>Exclusions: </strong>
            {isEmpty(exclusions) && 'None'}
          </p>
          <ul>
            {exclusions.map((exclusion, index) => {
              return <li key={index}>{exclusion.description}</li>
            })}
          </ul>
        </div>
        }
        <p>
          <strong>Admin Url: </strong> <a href={redirectUrl} target="_blank">{redirectUrl}</a>
        </p>
      </Panel>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/testResult/TestResult.js